import React from 'react';

import { useDisplayNameFormatter } from './useDisplayNameFormatter';
import User from 'types/User';


export type DisplayNameFormatterProps = { user? :Pick<User, 'firstName'|'lastName'|'displayName'> };

const DisplayNameFormatter: React.FC<DisplayNameFormatterProps> = ({ user }) => {
  const formatter = useDisplayNameFormatter();
  return (
    <React.Fragment>
      {formatter(user)}
    </React.Fragment>);
};

export default DisplayNameFormatter;
